module.exports = __webpack_public_path__ + "img/logo.dbdf0cc0.png";